import addCommasToNumbers from "./add-commas-to-numbers";

export default (x = 0, fixed = 2): string =>
  `$${addCommasToNumbers((x / 100).toFixed(fixed))}`;
